import React from "react";
import { action } from "storybook/actions";
import VStack from "../../ui_atoms/VStack";
import ListItem, { ListItemProps } from "../../ui_atoms/ListItem";
import ListHeader from "../../ui_atoms/ListHeader";
import { ScrollView } from "react-native";
import ListGroup from "../../components/ListGroup";
import { getAvatarUrl } from "../factories";
import { LabelMode } from "../../ui_atoms/Label";
import type { Meta, StoryObj } from "@storybook/react";

const ListItemStoriesNonPressableStory: React.FC<ListItemProps> = (props) => {
    return (
        <ScrollView style={{ flex: 1, alignSelf: "stretch" }}>
            <VStack
                style={{
                    margin: 0,
                }}
            >
                <ListHeader value="Non press-able" />
                <ListItem title="Main title" />
                <ListItem title="Main title with logo" avatarPath={getAvatarUrl()} />
                <ListItem {...props} labels={[{ text: "just label" }]} />
                <ListItem title="Main title" badge={<ListItem.TextBadge text="TextBadge" />} />
                <ListItem title="Main title" isShaded />
                <ListItem title="Main title" checked />
                <ListItem
                    title="Large title to see how displaying it on two lines affect its rendering"
                    checked
                />
                <ListItem
                    icon="company"
                    description="Ceci est la description donnée par le manager qui a engagé Yvanka pour une durée indéterminée en tant que graphiste. Elle va pouvoir lire ici en brève description de ce qui avait été discuté en direct avec le manager de chez Flo..."
                />
                <ListItem
                    icon="file"
                    title="Drive my car"
                    description="Hello Ceci est la **description** donnée par le manager qui a engagé Yvanka pour une durée indéterminée en tant que graphiste. Elle va pouvoir lire ici en brève description de ce qui avait été discuté en direct avec le manager de chez Flo..."
                    labels={[
                        {
                            text: "This is a label",
                            mode: "default",
                        },
                    ]}
                />
                <ListItem
                    icon="file"
                    title="Drive my car"
                    maxDescriptionLines={2}
                    description="Ceci est la **description** donnée par le manager qui a engagé Yvanka pour une durée indéterminée en tant que graphiste. Elle va pouvoir lire ici en brève description de ce qui avait été discuté en direct avec le manager de chez Flo..."
                />
                <ListItem
                    icon="file"
                    title="Drive my car"
                    maxDescriptionLines={2}
                    description="Ceci est la **description** donnée par le manager qui a engagé Yvanka pour une durée indéterminée en tant que graphiste. Elle va pouvoir lire ici en brève description de ce qui avait été discuté en direct avec le manager de chez Flo..."
                    labels={[
                        {
                            text: "This is a label",
                            mode: "default",
                        },
                    ]}
                />
            </VStack>
        </ScrollView>
    );
};

const ListItemStoriesPressableStory: React.FC<ListItemProps> = (props) => {
    return (
        <ScrollView style={{ flex: 1, alignSelf: "stretch" }}>
            <VStack
                style={{
                    margin: 0,
                }}
            >
                <ListHeader value="Press-able" />
                <ListItem title="Press-able item" onPress={action("List item press")} />
                <ListItem
                    {...props}
                    labels={[{ text: "pressable label" }]}
                    onPress={action("List label press")}
                />
                <ListItem
                    icon="user"
                    {...props}
                    labels={[{ text: "Long text with pressable action to see how it behave" }]}
                    onPress={action("List label press")}
                />

                <ListItem
                    title="Press-able with description"
                    description="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
                    onPress={action("List item press")}
                />
                <ListItem
                    {...props}
                    title="Press-able with description and label"
                    description="Lorem Ipsum is simply dummy text of the printing "
                    labels={[{ text: "This is a label" }]}
                    onPress={action("List item press")}
                />
                <ListItem
                    {...props}
                    title="Press-able with description, tags and label"
                    //checked
                    description="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
                    labels={[{ text: "This is a label" }]}
                    tags={["one", "12-apr-2022", "John Doe"]}
                    onPress={action("List item press")}
                />
                <ListItem
                    {...props}
                    title="Press-able with description, tags and label"
                    checked
                    description="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
                    labels={[{ text: "This is a label" }]}
                    tags={["one", "12-apr-2022", "John Doe"]}
                    onPress={action("List item press")}
                    avatarPath={getAvatarUrl()}
                />
                <ListItem
                    {...props}
                    title="Press-able with description, tags and label"
                    checked
                    description="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
                    labels={[{ text: "This is a label" }]}
                    tags={["one", "12-apr-2022", "John Doe"]}
                    onPress={action("List item press")}
                    avatarPath={getAvatarUrl()}
                    useBigAvatarOrIcon
                />
                <ListItem
                    {...props}
                    title="Press-able with description, tags and label"
                    checked
                    description="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
                    labels={[{ text: "This is a label" }]}
                    tags={["one", "12-apr-2022", "John Doe"]}
                    onPress={action("List item press")}
                    icon="user"
                    useBigAvatarOrIcon
                />
            </VStack>
        </ScrollView>
    );
};
type StoryProps = { labelMode?: LabelMode; value: string; unread?: boolean };

const ListStory: React.FC<StoryProps> = ({ labelMode, ...props }) => {
    const items = [
        {
            title: "Simple title",
        },
        {
            title: "Title and description",
            description:
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        },
        {
            title: "Title and description and label",
            description:
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            labels: [{ text: "This is a label", mode: labelMode }],
            onPress: action("List item press"),
        },
        {
            title: "With an avatar url and label",
            description:
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            labels: [{ text: "This is a label", mode: labelMode }],
            avatarPath: getAvatarUrl(),
        },
        {
            title: "With an avatar url an tags",
            description:
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            tags: ["This is a tag1", "an another one"],
            avatarPath: getAvatarUrl(),
        },
        {
            title: "With an avatar url LARGE",
            description:
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            labels: [{ text: "This is a label", mode: labelMode }],
            avatarPath: getAvatarUrl(),
            useBigAvatarOrIcon: true,
            tags: ["one", "two", "three"],
        },
    ].map((item) => ({ ...item, ...props }));

    return (
        <ScrollView style={{ flex: 1, alignSelf: "stretch" }}>
            <ListGroup isItemsCheckable={false} items={items} alignment="stretch" />
        </ScrollView>
    );
};

const SelectListItemStory: React.FC<ListItemProps> = () => {
    const [selectedIndex, setSelectedIndex] = React.useState(0);

    return (
        <ScrollView style={{ flex: 1, alignSelf: "stretch" }}>
            <VStack style={{ width: "100%" }}>
                <ListItem
                    selectable
                    title="This is a title"
                    tags={["tag1", "tag2"]}
                    labels={[{ text: "This is a label", mode: "warning" }]}
                    description="This is a description swpan on multiple line if the cell is too small"
                    avatarPath={getAvatarUrl()}
                    checked={selectedIndex === 0}
                    onPress={() => setSelectedIndex(0)}
                />
                <ListItem
                    selectable
                    title="This is a title"
                    avatarPath={getAvatarUrl()}
                    tags={["tag1", "tag2"]}
                    useBigAvatarOrIcon
                    checked={selectedIndex === 1}
                    onPress={() => setSelectedIndex(1)}
                />
                <ListItem
                    selectable
                    title="This is a title"
                    avatarPath={getAvatarUrl()}
                    description="additional informations"
                    useBigAvatarOrIcon
                    checked={selectedIndex === 2}
                    onPress={() => setSelectedIndex(2)}
                />
                <ListItem
                    selectable
                    title="This is a title"
                    checked={selectedIndex === 3}
                    onPress={() => setSelectedIndex(3)}
                />
                <ListItem
                    selectable
                    icon="user"
                    title="This is a title"
                    checked={selectedIndex === 4}
                    onPress={() => setSelectedIndex(4)}
                />
                <ListItem
                    selectable
                    title="This is a title with avatar"
                    tags={["tag1", "tag2"]}
                    avatarPath={getAvatarUrl()}
                    disabled
                />
                <ListItem selectable title="This is a title" tags={["tag1", "tag2"]} disabled />
                <ListItem selectable title="This is a title" disabled />
                <ListItem
                    selectable
                    description="This is a description"
                    tags={["tag1", "tag2"]}
                    checked={selectedIndex === 5}
                    onPress={() => setSelectedIndex(5)}
                />
                <ListItem
                    selectable
                    description="This is a description"
                    checked={selectedIndex === 6}
                    onPress={() => setSelectedIndex(6)}
                />
            </VStack>
        </ScrollView>
    );
};

const meta = {
    title: "Atom/ListItem",
    component: ListItemStoriesNonPressableStory,
    argTypes: {},
} satisfies Meta<typeof ListItemStoriesNonPressableStory>;

export default meta;

type Story = StoryObj<typeof meta>;

export const ListItemNonPressable: Story = (props: StoryProps) => (
    <ListItemStoriesNonPressableStory {...props} />
);

ListItemNonPressable.storyName = "List items non-pressable";

ListItemNonPressable.args = {
    labels: [],
    unread: false,
};
ListItemNonPressable.argTypes = {
    labels: {
        options: [
            [{ text: "text", mode: "default" }],
            [{ text: "text", mode: "warning" }],
            [{ text: "text", mode: "error" }],
            [{ text: "text", mode: "success" }],
            [{ text: "text", mode: "info" }],
            [{ text: "text", mode: "cta" }],
            [{ text: "text", mode: "anchor" }],
        ],
        control: { type: "radio" },
    },
    unread: {
        control: { type: "boolean" },
    },
};

export const ListItemPressable: Story = (props: StoryProps) => (
    <ListItemStoriesPressableStory {...props} />
);

ListItemPressable.storyName = "List items pressable";

ListItemPressable.args = {
    labels: [],
    unread: false,
};
ListItemPressable.argTypes = {
    labels: {
        options: [
            [{ text: "text", mode: "default" }],
            [{ text: "text", mode: "warning" }],
            [{ text: "text", mode: "error" }],
            [{ text: "text", mode: "success" }],
            [{ text: "text", mode: "info" }],
            [{ text: "text", mode: "cta" }],
            [{ text: "text", mode: "anchor" }],
        ],
        control: { type: "radio" },
    },
    unread: {
        control: { type: "boolean" },
    },
};

export const ListItemsInList = (props: StoryProps) => <ListStory {...props} />;

ListItemsInList.storyName = "List items in list";

ListItemsInList.parameters = {
    args: {
        labels: [],
        unread: false,
    },
    argTypes: {
        labels: {
            options: [
                [{ text: "text", mode: "default" }],
                [{ text: "text", mode: "warning" }],
                [{ text: "text", mode: "error" }],
                [{ text: "text", mode: "success" }],
                [{ text: "text", mode: "info" }],
                [{ text: "text", mode: "cta" }],
                [{ text: "text", mode: "anchor" }],
            ],
            control: { type: "radio" },
        },
        unread: {
            control: { type: "boolean" },
        },
    },
};

export const ListItemsSelectable = () => <SelectListItemStory />;

ListItemsSelectable.storyName = "List items selectable";
ListItemsSelectable.parameters = {};
